// extracted by mini-css-extract-plugin
module.exports = {"dash":"Dashboard_dash__2c-Hq","sub":"Dashboard_sub__1j0xl","btn":"Dashboard_btn__PsPGW","btnsection":"Dashboard_btnsection__3ISaZ"};